import { render } from "./roomDetail.vue?vue&type=template&id=9799df3a&scoped=true"
import script from "./roomDetail.vue?vue&type=script&lang=js"
export * from "./roomDetail.vue?vue&type=script&lang=js"

import "./roomDetail.vue?vue&type=style&index=0&id=9799df3a&lang=scss&scoped=true"
import "./roomDetail.vue?vue&type=style&index=1&id=9799df3a&lang=scss"
script.render = render
script.__scopeId = "data-v-9799df3a"

export default script